var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(_vm._s(_vm.$t('base.spamTitle')))]),_c('div',{directives:[{name:"marked",rawName:"v-marked",value:(_vm.$t('base.spam')),expression:"$t('base.spam')"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }